import React, { Component } from "react";
import TheChamps from "../images/H2_Large_TheChamps.svg";
import TheChampsSmall from "../images/H2_Small_TheChamps.svg";
import { Fade } from "react-awesome-reveal";

export default class ArchiveHero extends Component {
  render() {
    return (
      <div>
        <Fade triggerOnce>
          <img
            src={TheChamps}
            alt="The Champs"
            className="hidden md:block ml-auto mr-auto"
          />
          <img
            src={TheChampsSmall}
            alt="The Champs"
            className="block md:hidden mr-auto"
          />
        </Fade>
        <div className="md:my-20 lg:my-40">
          <div className="flex">
            <div className="my-20 lg:w-1/2 lg:ml-auto lg:pl-20 lg:pr-20 xl:pr-32">
              <Fade triggerOnce>
                <p className="text-2xl leading-10">
                  We have been killing the Halloween Game for years. Take a look
                  at previous parties from simpler times.
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
